export const scrollToSection = (selector) => {
  const lenis = window.__lenis;
  if (lenis) {
    lenis.scrollTo(selector, { offset: -104, duration: 1.4 });
  } else {
    document.querySelector(selector)?.scrollIntoView({ behavior: "smooth" });
  }
};
